window.addEventListener('load', event => {
    // Widget Panels
    // Sometimes widget panel doesn't load the required iframe - this is a fallback in case that occurs
    // Waits 15 secs, checks if <healcode-widget> element is present and has content, if not display reload message

    let widgetPanels = document.querySelectorAll('.widget-panel,.widget-block');
    for (let widgetPanel of widgetPanels) {
        let widgetPresent = false;

        let interval = setInterval(function () {
            if (widgetPresent) {
                clearInterval(interval);
            }
            else {
                let widget = widgetPanel.querySelector('healcode-widget > *');
                let loadingMessage = widgetPanel.querySelector('div[data-loading][data-error]');
                if (!!widget) {
                    loadingMessage.dataset.loading = 'false';
                    widgetPresent = true;
                }
            }
        }, 200);

        let timeout = setTimeout(function () {
            if (!widgetPresent) {
                clearInterval(interval);
                let loadingMessage = widgetPanel.querySelector('div[data-loading][data-error]');
                loadingMessage.dataset.loading = 'false';
                loadingMessage.dataset.error = 'true';
            }
        }, 15000);
        
    }
});

